import React from "react";
import { Select } from "antd";
import { useQuery } from "react-query";

import { LookUpApiService } from "../../../ApiServices";
import notificationService from "../../../util/notification.service";
import { API_STORAGE_KEY } from "./../../../constants/constant";

const getCategory = async () => {
    const { ok, data, response } = await LookUpApiService.getFreebieCategory();
    if (ok) {
        return data;
    } else {
        notificationService.error(response.message);
        throw new Error(response.message);
    }
};

const CategoryLookup = (props) => {
    const { data: freebieCategory = [], isLoading } = useQuery(API_STORAGE_KEY.CATEGORY_LIST, getCategory);

    return (
        <>
            <Select
                {...props}
                showSearch
                filterOption={(input, option) => {
                    return option.props.children.toLowerCase().includes(input.toLowerCase());
                }}
                // style={{ width: "150px" }}
                allowClear
                loading={isLoading}
                disabled={isLoading}
                getPopupContainer={(triggerNode) => triggerNode.parentElement}
            >
                {freebieCategory?.map((data) => {
                    return (
                        <Select.Option key={data?.id} value={data.id}>
                            {data?.name}
                        </Select.Option>
                    );
                })}
            </Select>
        </>
    );
};
export default CategoryLookup;
